export const  obtenerTotalPorNeto = (neto: ReadonlyArray<number>): number[] => {
    let total: number[];
    total = [neto[0], neto[0]];
    return total;
}

